
import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { requestAuth } from "../components/services/RequestService";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const meses = [
  "ene", "feb", "mar", "abr",
  "may", "jun", "jul", "ago",
  "sep", "oct", "nov", "dic",
];

export function BarChart({ year }) {
  const [datosBackend, setDatosBackend] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let activo = true;

    const obtenerDatos = async () => {
      setLoading(true);
      setError(false);
      setDatosBackend(null);

      try {
        const gestion = Number(year);

        const response = await requestAuth(
          "GET",
          "/v2/ProcedureReport/bar",
          {},
          { gestion }
        );

        if (activo) {
          console.log(
            "RESPUESTA REAL DEL BACKEND MENSUAL:",
            response.data
          );

          setDatosBackend(response.data);
        }
      } catch (err) {
        if (activo) {
          console.error(
            "Error al consultar trámites mensuales:",
            err
          );
          setError(true);
        }
      } finally {
        if (activo) {
          setLoading(false);
        }
      }
    };

    obtenerDatos();

    return () => {
      activo = false;
    };
  }, [year]);

  // Leer los valores mensuales reales del backend
  const valoresMensuales = meses.map((mes) =>
    Number(datosBackend?.[mes] ?? 0)
  );

  const data = {
    labels: [
      "Ene", "Feb", "Mar", "Abr",
      "May", "Jun", "Jul", "Ago",
      "Sep", "Oct", "Nov", "Dic",
    ],
    datasets: [
      {
        label: "Trámites",
        data: valoresMensuales,
        backgroundColor: "rgba(5, 110, 252, 0.9)",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
      },
    },
  };

  if (loading) {
    return (
      <div className="w-full h-[300px] flex items-center justify-center">
        <p className="text-center">
          Cargando trámites mensuales...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full h-[300px] flex items-center justify-center">
        <p className="text-center text-red-500">
          No se pudieron cargar los trámites mensuales.
        </p>
      </div>
    );
  }

  if (
    !datosBackend ||
    typeof datosBackend !== "object" ||
    Array.isArray(datosBackend) ||
    !meses.every((mes) =>
      Object.prototype.hasOwnProperty.call(datosBackend, mes)
    )
  ) {
    return (
      <div className="w-full h-[300px] flex items-center justify-center">
        <p className="text-center text-gray-500">
          El backend no devolvió los datos mensuales esperados.
        </p>
      </div>
    );
  }

  return (
    <div className="w-full h-[300px]">
      <Bar data={data} options={options} />
    </div>
  );
}
